import { isLockedWidget } from '@/components/forms/utils/links';
import { Checkbox } from '@/shadcn/checkbox';
import { TestId } from '@/types/testId';
import { type WidgetWriterProps } from '../widget.type';
import { cn } from '@/shadcn/lib/utils';

export const CheckboxWidget = ({
  label,
  name,
  value,
  disabled,
  readonly,
  onChange,
  id,
  formContext,
  required
}: WidgetWriterProps) => {
  return (
    <div className="flex items-center space-x-2" key={id}>
      <Checkbox
        id={id}
        disabled={
          disabled || readonly || isLockedWidget(id, formContext?.links)
        }
        checked={typeof value === 'undefined' ? false : value}
        onCheckedChange={checked => onChange(checked)}
        data-testid={TestId.FormWriter.Checkbox.Checkbox}
        data-cy={`checkbox-${name}`}
        aria-label={label}
      />
      <label
        htmlFor={id}
        className={cn(
          'cursor-pointer text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          required && 'after:text-destructive after:ml-1 after:content-["*"]'
        )}
        data-testid={TestId.FormWriter.Checkbox.CheckboxLabel}
      >
        {label}
      </label>
    </div>
  );
};
